export default __webpack_public_path__ + "static/media/PW.e61f1623.svg";